const LABELS = {
  queued: "Invalidation is queued.",
  claimed: "Invalidation is in progress.",
  completed: "Invalidation job completed.",
  dlq: "Invalidation failed.",
  quarantined: "Invalidation failed.",
};

export const KNOWLEDGE_INVALIDATION_UNREAD = "Invalidation status could not be read.";

export function knowledgeInvalidationNotice(status) {
  if (typeof status !== "string") {
    return "not configured";
  }
  return LABELS[status] || "not configured";
}
